module.exports = __webpack_public_path__ + "img/tu-5.9efdcdb0.png";